import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../AdminLayout";
import DashboardHome from "../pages/DashboardHome";
import Users from "../pages/Users";
import Games from "../pages/Games";
import Settings from "../pages/Settings";
import Invoices from "../pages/Invoices";
import Bookings from "../pages/Bookings";
import Categories from "../pages/Categories";
import UserDetail from "../pages/UserDetail";
import Auth from "../pages/Auth";
import BookingDetail from "../pages/BookingDetail";
import PrivateRoute from "../components/PrivateRoute";
import GameDetails from "../pages/GameDetails";
import GameCreate from "../pages/GameCreate";
import CategoryDetails from "../pages/CategoryDetails";
import CategoryCreate from "../pages/CreateCategory";
const AdminRoutes = () => (
  <Routes>
    <Route path="/admin/login" element={<Auth />} />
    <Route path="/admin" element={<PrivateRoute />}>
      <Route element={<AdminLayout />}>
        <Route index element={<DashboardHome />} />
        <Route path="users" element={<Users />} />
        <Route path="games" element={<Games />} />
        <Route path="settings" element={<Settings />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="categories" element={<Categories />} />
        <Route path="users/:name" element={<UserDetail />} />
        <Route path="bookings/:id" element={<BookingDetail />} />
        <Route path="games/:id" element={<GameDetails />} />
        <Route path="games/create" element={<GameCreate />} />
        <Route path="categories/:id" element={<CategoryDetails />} />
        <Route path="categories/create" element={<CategoryCreate />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/admin" />} />
  </Routes>
);

export default AdminRoutes;
